import React from 'react'
import {Button, ListItemText, Menu, InputAdornment, IconButton, Tabs, Tab,Box,
  MenuItem ,Badge,Fab 
} from '@material-ui/core'
import {Search, Clear, FilterList} from '@material-ui/icons'
import {makeStyles} from '@material-ui/styles'
import {isUndefined,isEmpty, indexOf} from 'lodash'
import { useMediaQuery } from 'react-responsive';
import { injectIntl } from 'react-intl';

import { Autocomplete, TextField } from '@mui/material'
import HistoryIcon from '@mui/icons-material/History';
import moment from 'moment';
import {history} from "store"
import { useSelector,useDispatch } from 'react-redux'
import {OpenFilterPopUp} from 'actions'
import { useGetUserSearchHistory } from '../../../hooks/api/user/useGetUserSearchHistory'
import IntlMessages from 'util/IntlMessages';
import usePostUserSearchHistory from '../../../hooks/api/user/usePostUserSearchHistory'

const useStyles = makeStyles({
    tab: {
        // marginLeft: '15px',
        minWidth: '100px !important',
        minHeight: '44px !important'
    },
    tabs: {
        width: '100%',
        minHeight: '44px !important'
    },
    searchBox: {
      borderRadius: '0.375rem !important',
      "& input::placeholder": {
        fontSize: "16px"
      }
    },
    badge: {
      top: 5,
      right: 2,
      transform: 'scale(0.8) translate(50%, -50%)'
    },
    searchBoxDt: {
      transition: 'width 200ms',
      width: 250,
      borderRadius: '0.375rem !important',
      "& input::placeholder": {
        fontSize: "16px"
      },
      "&.Mui-focused, &:hover": {
        // border: "2px solid red",
        width: 300,
        
      }
    }
})


const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 992, maxWidth: 1199 })
    return isDesktop ? children : null
}
const LargeDesktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1200 })
    return isDesktop ? children : null
}
const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
}
const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
}

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

function TableHeader(props) {
    const classes = useStyles()
    const Searchlabel = props.intl.formatMessage({ id: 'Search' });
    const [searchtext, setsearchtext] = React.useState(isUndefined(props.searchtext) ? '' : props.searchtext)
    const [searchtype, setsearchtype] = React.useState(isUndefined(props.searchtype) ? '' : props.searchtype)
    //Jakc
    const dispatch = useDispatch()
    const userid = useSelector(state => state.auth.authUser.user_id) 
    const Afid = useSelector(state => state.auth.authUser.user_Afid) 
    const AvtalFilterOption = useSelector(state=>state.Avtal.AvtalFilterOption)
    const FilterOption = useSelector(state=>state.accountsData.FilterOption)
    const EsigneringFilterOption = useSelector(state=>state.Eisgnering.EsigneringFilterOption)
    const OrderFilterOption = useSelector(state=>state.Order.OrderFilterOption)
    const EventFilterOption = useSelector(state=>state.Event.EventFilterOption)
    const ArendeFilterOption = useSelector(state=>state.Ärende.ArendeFilterOption)
    const ProjektFilterOption = useSelector(state=>state.Projekt.ProjektFilterOption)
    const ArtiklarFilterOption = useSelector(state=>state.ArtikelReg.ArtiklarFilterOption)
    const OffertFilterOption = useSelector(state=>state.OffertPrev.OffertFilterOption)
    const UserFilterOption = useSelector(state => state.userData.UserFilterOption)
    const SMSFilterOption = useSelector(state => state.userData.SMSFilterOption)
    const CampiagnFilterOption = useSelector(state => state.MailTempEditor.CampiagnFilterOption)

		const {mutate} = usePostUserSearchHistory()
		const {data, isLoading} = useGetUserSearchHistory(props.Source, searchtext)

    //

    // const [currTab, setCureTab] = React.useState(0)
    // const handleSearch = (e) => {
    //     props.handleChangeState('searchword', e.target.value)
    //     if(e.keyCode === 13){
    //         setFilterName(e.target.value === "" ?'Pågående':'Alla')
    //         dispatch(getProjects(Afid, Userid, 0, props.pageSize, e.target.value, e.target.value === "" ? 1 : 3, props.filterState))
    //     }
    // }
    const _handleSearch = (e) => {
        if(e.keyCode === 13) { 
          // if(!isUndefined(props.handleSearchChange)) props.handleSearchChange({target: {value: searchtext}})
					if(!isUndefined(props.Source)) mutate({Keyword: searchtext, Source: props.Source})
          props.handleSearch({target: {value: searchtext}}) 
        }
    }
    const _handleSearchBtn = (e) => {
      // if(!isUndefined(props.handleSearchChange)) props.handleSearchChange({target: {value: searchtext}})
			if(!isUndefined(props.Source)) mutate({Keyword: searchtext, Source: props.Source})
      props.handleSearch({target: {value: searchtext}}) 
    }

    const handleTabChange = (e,v) => {
        if(!isUndefined(props.handleClickTab)) {
            props.handleClickTab(props.tabs[v], v)
        }
    }

    const retriveIndexFromValue = () => {
        if(isUndefined(props.tabs)) return 0
        if(isEmpty(props.tabs)) return 0
        return indexOf(props.tabs, props.tabs.find(t => t.value === props.currTabIndex))
    }

    const handleClear = () => {
      setsearchtext('')
      // if(!isUndefined(props.handleSearchChange)) props.handleSearchChange({target: {value: ''}})
      props.handleSearch({target: {value: ''}}) 
    }
//
const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  //
  const checkIfFilterOn = () => {
    const _page = history.location.pathname.split('/')[2]
    switch(_page){
      case "Avtal": return isEmpty(AvtalFilterOption)
      case "Kunder": return isEmpty(FilterOption)
      case "Esignering": return isEmpty(EsigneringFilterOption)
      case "Order": return isEmpty(OrderFilterOption)
      case "Möte": return isEmpty(EventFilterOption)
      case "Ärende": return isEmpty(ArendeFilterOption)
      case "Projekt": return isEmpty(ProjektFilterOption)
      case "Artiklar": return isEmpty(ArtiklarFilterOption)
      case "v2": return isEmpty(OffertFilterOption)
      case "Users": return isEmpty(UserFilterOption)
      case "SMScenter": return isEmpty(SMSFilterOption)
      case "Kampanj": return isEmpty(CampiagnFilterOption)
      
    /*  case "Prospekt": return isEmpty(this.props.ProspektFilterOption)
      
      case "KunderV2": return isEmpty(this.props.FilterOption)
      case "Aktiviteter": return isEmpty(this.props.AktiviterFilterOption)
     
      
      
      
      
      
      case "ProjektKort": return isEmpty(this.props.ProjektKortFilterOption)
      case "Dashboard": return isEmpty(this.props.DashboardFilterOption)
      case "DashboardAnpassad": return isEmpty(this.props.DashboardAnpassadFilterOption)
      case "DashboardSalj": return isEmpty(this.props.DashboardSaljFilterOption)
      case "DashboardBokning": return isEmpty(this.props.DashboardBokaFilterOption)
      case "DashboardDialer": return isEmpty(this.props.DashboardDialerFilterOption)
      case "DashboardOrder": return isEmpty(this.props.DashboardOrderFilterOption)
      case "DashboardBarn": return isEmpty(this.props.DashboardBarnFilterOption)
      case "Dashboardprospekt": return isEmpty(this.props.DashboardProspektFilterOption)
      case "DashboardV2": return isEmpty(this.props.DashboardFilterOption)
      case "DashboardSaljV2": return isEmpty(this.props.DashboardSaljFilterOption)
      case "DashboardBokningV2": return isEmpty(this.props.DashboardBokaFilterOption)
      case "DashboardDialerV2": return isEmpty(this.props.DashboardDialerFilterOption)
      case "DashboardOrderV2": return isEmpty(this.props.DashboardOrderFilterOption)
      case "DashboardBarnV2": return isEmpty(this.props.DashboardBarnFilterOption)
      case "DashboardprospektV2": return isEmpty(this.props.DashboardProspektFilterOption)
      case "DashboardKontor": return isEmpty(this.props.DashboardKontorFilterOption)
      
      
      */
      default: return true
    }


  }
  const constReturnFilterCount = () => {
    const _page = history.location.pathname.split('/')[2]
    console.log(_page,"AvtalFilterOption.length")
    switch(_page){
      case "Avtal": return isUndefined(AvtalFilterOption)?0:AvtalFilterOption.length
      case "Kunder": return isUndefined(FilterOption)?0:FilterOption.length
      case "Esignering": return isUndefined(EsigneringFilterOption)?0:EsigneringFilterOption.length
      case "Order": return isUndefined(OrderFilterOption)?0:OrderFilterOption.length
      case "Möte": return isUndefined(EventFilterOption)?0:EventFilterOption.length
      case "Ärende": return isUndefined(ArendeFilterOption)?0:ArendeFilterOption.length
      case "Projekt": return isUndefined(ProjektFilterOption)?0:ProjektFilterOption.length
      case "Artiklar": return isUndefined(ArtiklarFilterOption)?0:ArtiklarFilterOption.length
      case "v2": return isUndefined(OffertFilterOption)?0:OffertFilterOption.length
      case "Users": return isUndefined(UserFilterOption)?0:UserFilterOption.length
      case "SMScenter": return isUndefined(SMSFilterOption)?0:SMSFilterOption.length
      case "Kampanj": return isUndefined(CampiagnFilterOption)?0:CampiagnFilterOption.length
      /* case "Prospekt": return isUndefined(this.props.ProspektFilterOption)?0:this.props.ProspektFilterOption.length
      
      case "KunderV2": return isUndefined(this.props.FilterOption)?0:this.props.FilterOption.length
      case "Aktiviteter": return isUndefined(this.props.AktiviterFilterOption)?0:this.props.AktiviterFilterOption.length
     
      
      
      
      
      case "ProjektKort": return isUndefined(this.props.ProjektKortFilterOption)?0:this.props.ProjektKortFilterOption.length
      case "Dashboard": return isUndefined(this.props.DashboardFilterOption)?0:this.props.DashboardFilterOption.length
      case "DashboardAnpassad": return isUndefined(this.props.DashboardAnpassadFilterOption)?0:this.props.DashboardAnpassadFilterOption.length
      case "DashboardSalj": return isUndefined(this.props.DashboardSaljFilterOption)?0:this.props.DashboardSaljFilterOption.length
      case "DashboardBokning": return isUndefined(this.props.DashboardBokaFilterOption)?0:this.props.DashboardBokaFilterOption.length
      case "DashboardDialer": return isUndefined(this.props.DashboardDialerFilterOption)?0:this.props.DashboardDialerFilterOption.length
      case "DashboardOrder": return isUndefined(this.props.DashboardOrderFilterOption)?0:this.props.DashboardOrderFilterOption.length
      case "DashboardBarn": return isUndefined(this.props.DashboardBarnFilterOption)?0:this.props.DashboardBarnFilterOption.length
      case "Dashboardprospekt": return isUndefined(this.props.DashboardProspektFilterOption)?0:this.props.DashboardProspektFilterOption.length
      case "DashboardV2": return isUndefined(this.props.DashboardFilterOption)?0:this.props.DashboardFilterOption.length
      case "DashboardSaljV2": return isUndefined(this.props.DashboardSaljFilterOption)?0:this.props.DashboardSaljFilterOption.length
      case "DashboardBokningV2": return isUndefined(this.props.DashboardBokaFilterOption)?0:this.props.DashboardBokaFilterOption.length
      case "DashboardDialerV2": return isUndefined(this.props.DashboardDialerFilterOption)?0:this.props.DashboardDialerFilterOption.length
      case "DashboardOrderV2": return isUndefined(this.props.DashboardOrderFilterOption)?0:this.props.DashboardOrderFilterOption.length
      case "DashboardBarnV2": return isUndefined(this.props.DashboardBarnFilterOption)?0:this.props.DashboardBarnFilterOption.length
      case "DashboardprospektV2": return isUndefined(this.props.DashboardProspektFilterOption)?0:this.props.DashboardProspektFilterOption.length
      case "DashboardKontor": return isUndefined(this.props.DashboardKontorFilterOption)?0:this.props.DashboardKontorFilterOption.length
      
      
      */
      default: return true
    }
  }
  const handlePopoverOpenPage=()=>{
    const _page = history.location.pathname.split('/')[2]
    let page = _page === "KunderV2"?"Kunder":_page
    dispatch(OpenFilterPopUp(userid, Afid, page))
  }
  //
    if(useMediaQuery({ maxWidth: 767 })) {
        return (
            <div className="d-flex align-items-center justify-content-between flex-column w-100">
                <div className="d-flex align-items-center w-100 mb-2">
                {
                    isUndefined(props.tabs) || isEmpty(props.tabs) ? '' :
                        <Tabs 
                            textColor="primary" 
                            indicatorColor="primary" 
                            value={retriveIndexFromValue(props.currTabIndex)} 
                            onChange={(e, v) => handleTabChange(e, v)} 
                            classes={{root: classes.tabs}}
                            variant="scrollable"
                            scrollButtons="auto"
                            >
                            {props.tabs.map((t,i) => <Tab label={<span className='d-flex align-items-center' style={{height:24.5}}>{isUndefined(t.icon) ? '' : <span className='mr-1'>{t.icon}</span>}<span>{t.label}</span></span>} index={i} classes={{root: classes.tab}}/>)}
                        </Tabs>
                }
                </div>
                <div className="d-flex align-items-center w-100 mb-2">
                    {
                      isUndefined(props.Filter)?"":
                      props.Filter?
                      <Badge color="secondary" 
                      className='mr-2'
                        classes={{anchorOriginTopRightRectangle: classes.badge}} 
                        invisible={checkIfFilterOn()} 
                        badgeContent={constReturnFilterCount()}
                        >
                      {/* <Fab size="small" className={''} >
                        <i className="zmdi zmdi-filter-list zmdi-hc-fw"/>
                      </Fab> */}
                      <Fab onClick={handlePopoverOpenPage}
                      className="jr-fab-btn bg-primary text-white jr-btn-fab-xs m-0"
                      >
                        <FilterList style={{fontSize: 20}}/>
                      </Fab>
                      </Badge>
                      :""
                    }
                   {isUndefined(props.addPopUp) ? '' : <div className='mr-2'>{props.addPopUp}</div>}
									{!props.hideSearch &&
									<Autocomplete
										fullWidth
										style={{ backgroundColor: '#fff'}}
										size='small'
										freeSolo
										onKeyDown={_handleSearch}
										options={!data ? [] : data.SearchHistory.map(s => ({...s, label: s.Keyword}))}
										filterOptions={(options, filter) => {
											if(filter.inputValue === "")
												return options
											else
												return options.filter(o => 
													String(o.label).replace(/\s/g, '').toUpperCase().includes(String(filter.inputValue).replace(/\s/g, '').toUpperCase()) 
												)
										}}
										componentsProps={{
											popper: {style: {width:'fit-content'}, placement:'bottom-end'},
										}}
										sx={{
											minWidth: {xs: 'unset', sm: '259px'},
											"& .MuiOutlinedInput-root": {
													paddingRight: "20px !important",
													borderRadius: '0.375rem !important',
											},
											"& .MuiOutlinedInput-notchedOutline": {
													border: "1px solid #C4C4C4"
											},
											"& input::placeholder": {
												fontSize: "16px"
											},
										}}
										renderOption={(props, option)=>{
											return (
												<MenuItem {...props}>
													<div className='d-flex align-items-center justify-content-between w-100' style={{gap: 20, color: '#2f353a'}}>
														<span style={{whiteSpace: 'nowrap', gap: 5}} className='d-flex align-items-center'>
															<HistoryIcon/>
															<span>{option.label}</span>
														</span>

														<small style={{whiteSpace: 'nowrap'}}>{moment().diff(option.sdate) > 0 ? moment(option.sdate).fromNow() : moment().fromNow()}</small>
													</div>
												</MenuItem>
											)
										}}
										loadingText={<IntlMessages id="Search.Loading"/>}
										onChange={(e, value)=> {
											console.log(e, value, 'vvalse')
											if(value?.label) setsearchtext(value.label)
										}}	
										value={searchtext}
										loading={isLoading && !isUndefined(props.Source)}
										renderInput={(params) => <TextField {...params} 
											id="standard-start-adornment"
											onChange={(e)=> {
												setsearchtext(e.target.value)
											}} 
											placeholder={Searchlabel} 
											variant='outlined'
											InputProps={{
												...params.InputProps,
												classes: {
													// root: classes.searchBoxDt,
												},
												startAdornment:searchtype === ""?"":<>
												<Button aria-controls="serach-menu" aria-haspopup="true" onClick={handleClick} size="small"
												style={{fontSize: "12px", padding: '4px !important'}}>
													{props.searchtypeMenu.filter(item=>item.value === searchtype)[0].ShLabel}
												</Button>
												<Menu
												id='serach-menu'
												anchorEl={anchorEl}
												keepMounted
												open={Boolean(anchorEl)}
												onClose={handleClose}
												>
													{
														props.searchtypeMenu.map(item=>{
															return <MenuItem onClick={()=>{
																setsearchtype(item.value)
																props.onchangeSearchTyp(item.value)
																handleClose()
															}}>{item.label}</MenuItem>
														})
													}
												</Menu>

												</>,
												endAdornment: <InputAdornment position="end" style={{marginRight: -8}}>
													{
														props.searchtext === '' || isUndefined(props.searchtext) ?
														<IconButton size="small" onClick={_handleSearchBtn}><Search/></IconButton> :
														<IconButton size="small" onClick={handleClear}><Clear/></IconButton>
													}
													</InputAdornment>,
				
											}}
										/>}
									/>

                    // <TextField
                    //   fullWidth
                    //   placeholder={Searchlabel}
                    //   id="standard-start-adornment"
                    //   className={'mr-2'}
                    //   InputProps={{
                    //     classes: {
                    //       root: classes.searchBox,
                    //     },
                    //     startAdornment:searchtype === ""?"":<>
                    //     <Button aria-controls="serach-menu" aria-haspopup="true" onClick={handleClick}
                    //     style={{fontSize: "12px",left: "-15px"}}>
                    //       {props.searchtypeMenu.filter(item=>item.value === searchtype)[0].ShLabel}
                    //     </Button>
                    //     <Menu
                    //     id='serach-menu'
                    //     anchorEl={anchorEl}
                    //     keepMounted
                    //     open={Boolean(anchorEl)}
                    //     onClose={handleClose}
                    //     >
                    //       {
                    //         props.searchtypeMenu.map(item=>{
                    //           return <MenuItem onClick={()=>{
                    //             setsearchtype(item.value)
                    //             props.onchangeSearchTyp(item.value)
                    //             handleClose()
                    //           }}>{item.label}</MenuItem>
                    //         })
                    //       }
                    //     </Menu>

                    //     </>,
                    //     endAdornment: <InputAdornment position="end" style={{marginRight: -8}}>
                    //       {
                    //         props.searchtext === '' || isUndefined(props.searchtext) ?
                    //         <IconButton size="small" onClick={_handleSearchBtn}><Search/></IconButton> :
                    //         <IconButton size="small" onClick={handleClear}><Clear/></IconButton>
                    //       }
                    //       </InputAdornment>,
        
                    //   }}
                    //   size="small"
                    //   variant="outlined"
                    //   onKeyDown={_handleSearch}
                    //   // onChange={(e) => isUndefined(props.handleSearchChange) ? () => {} : props.handleSearchChange(e)}
                    //   onChange={(e) => setsearchtext(e.target.value)}
                    // />
									}
                </div>
                {isUndefined(props.actions) ? '' : 
                    <div className="d-flex align-items-center w-100">
                        {props.actions}
                    </div>
                }
            </div>
        )   
    }
    

    return (
        <div className={`d-flex  justify-content-between pl-2  "align-items-center"`}>
            <div className={`d-flex align-items-center`} >
            {isUndefined(props.addPopUp) ? '' : props.addPopUp}
            {isUndefined(props.actions) ? '' : props.actions}
            {
                isUndefined(props.tabs) || isEmpty(props.tabs) ? '' :
                <Box>
                    <Tabs 
                        textColor="primary" 
                        indicatorColor="primary" 
                        value={retriveIndexFromValue(props.currTabIndex)} 
                        onChange={(e, v) => handleTabChange(e, v)} 
                        classes={{root: classes.tabs}}
                        variant="scrollable"
                        scrollButtons="auto"
                        style={{ 
                          maxWidth:(window.innerWidth < 1200)? "56vw" :"unset" 
                        }}
                        >
                        {props.tabs.map((t,i) => <Tab key={i} label={<span className='d-flex align-items-center' style={{height:24.5}}>{isUndefined(t.icon) ? '' : <span className='mr-1'>{t.icon}</span>}<span>{t.label}</span></span>} index={i} classes={{root: classes.tab}}/>)}
                    </Tabs>
                </Box>
            }
            </div>
            <div style={{alignSelf:"end"}} className='d-flex align-items-center'>
            {
              isUndefined(props.Filter)?"":
              props.Filter?
               <Badge color="secondary" 
               className='mr-3'
                 classes={{anchorOriginTopRightRectangle: classes.badge}} 
                 invisible={checkIfFilterOn()} 
                 badgeContent={constReturnFilterCount()}
                 >
              {/* <Fab size="small" className={'mr-2'} onClick={handlePopoverOpenPage}>
                <i className="zmdi zmdi-filter-list zmdi-hc-fw"/>
              </Fab> */}
              <Fab onClick={handlePopoverOpenPage}
              className="jr-fab-btn bg-primary text-white jr-btn-fab-xs m-0"
              >
                <FilterList style={{fontSize: 20}}/>
              </Fab>
              </Badge>
              :""
            }
							{!props.hideSearch &&
								<Autocomplete
									style={{ backgroundColor: '#fff'}}
									size='small'
									freeSolo
									onKeyDown={_handleSearch}
									options={!data ? [] : data.SearchHistory.map(s => ({...s, label: s.Keyword}))}
									filterOptions={(options, filter) => {
										if(filter.inputValue === "")
											return options
										else
											return options.filter(o => 
												String(o.label).replace(/\s/g, '').toUpperCase().includes(String(filter.inputValue).replace(/\s/g, '').toUpperCase()) 
											)
									}}
									componentsProps={{
										popper: {style: {width:'fit-content'}, placement:'bottom-end'},
									}}
									sx={{
										minWidth: {xs: '158px', sm: '259px'},
										"& .MuiOutlinedInput-root": {
												paddingRight: "20px !important",
												borderRadius: '0.375rem !important',
										},
										"& .MuiOutlinedInput-notchedOutline": {
												border: "1px solid #C4C4C4"
										},
										transition: 'width 200ms',
										width: 250,
										"& input::placeholder": {
											fontSize: "16px"
										},
										"&.Mui-focused, &:hover": {
											width: 300,
										}
									}}
									renderOption={(props, option)=>{
										return (
											<MenuItem {...props}>
												<div className='d-flex align-items-center justify-content-between w-100' style={{gap: 20, color: '#2f353a'}}>
													<span style={{whiteSpace: 'nowrap', gap: 5}} className='d-flex align-items-center'>
														<HistoryIcon/>
														<span>{option.label}</span>
													</span>

													<small style={{whiteSpace: 'nowrap'}}>{moment().diff(option.sdate) > 0 ? moment(option.sdate).fromNow() : moment().fromNow()}</small>
												</div>
											</MenuItem>
										)
									}}
									loadingText={<IntlMessages id="Search.Loading"/>}
									onChange={(e, value)=> {
										console.log(e, value, 'vvalse')
										if(value?.label) setsearchtext(value.label)
									}}	
									
									value={searchtext}
									loading={isLoading && !isUndefined(props.Source)}
									renderInput={(params) => <TextField {...params} 
										id="standard-start-adornment"
										onChange={(e)=> {
											setsearchtext(e.target.value)
										}} 
										variant='outlined'
										placeholder={Searchlabel} 
										InputProps={{
											...params.InputProps,
											classes: {
												// root: classes.searchBoxDt,
											},
											startAdornment:searchtype === ""?"":<>
											<Button aria-controls="serach-menu" aria-haspopup="true" size='small' onClick={handleClick}
												style={{fontSize: "12px", padding: '4px !important'}}>
												{props.searchtypeMenu.filter(item=>item.value === searchtype)[0].ShLabel}
											</Button>
											<Menu
											id='serach-menu'
											anchorEl={anchorEl}
											keepMounted
											open={Boolean(anchorEl)}
											onClose={handleClose}
											>
												{
													props.searchtypeMenu.map(item=>{
														return <MenuItem onClick={()=>{
															setsearchtype(item.value)
															props.onchangeSearchTyp(item.value)
															handleClose()
														}}>{item.label}</MenuItem>
													})
												}
											</Menu>

											</>,
											endAdornment: <InputAdornment position="end" style={{marginRight: -8}}>
												{
													props.searchtext === '' || isUndefined(props.searchtext) ?
													<IconButton size="small" onClick={_handleSearchBtn}><Search/></IconButton> :
													<IconButton size="small" onClick={handleClear}><Clear/></IconButton>
												}
												</InputAdornment>,
			
										}}
									/>}
								/>
								// <TextField
								// 	value={searchtext}
								// 	placeholder={Searchlabel}
								// 	id="standard-start-adornment"
								// 	className={'mr-2'}
								// 	InputProps={{
								// 		classes: {
								// 			root: classes.searchBoxDt,
								// 		},
								// 		startAdornment:isUndefined(props.searchtype)?"":<>
								// 		<Button aria-controls="serach-menu" aria-haspopup="true" onClick={handleClick}
								// 		style={{fontSize: "12px",left: "-15px"}}>
								// 							{console.log(searchtype)}
								// 							{console.log(props.searchtypeMenu)}
								// 							{
								// 							isEmpty(props.searchtypeMenu.filter(item=>item.value === searchtype))?"":props.searchtypeMenu.filter(item=>item.value === searchtype)[0].ShLabel
								// 							}
								// 						</Button>
								// 						<Menu
								// 						id="serach-menu"
								// 						anchorEl={anchorEl}
								// 						keepMounted
								// 						open={Boolean(anchorEl)}
								// 						onClose={handleClose}
								// 						>
								// 							{
								// 								props.searchtypeMenu.map(item=>{
								// 									return <MenuItem onClick={()=>{
								// 										setsearchtype(item.value)
								// 										props.onchangeSearchTyp(item.value)
								// 										handleClose()
								// 									}}>{item.label}</MenuItem>
								// 								})
								// 							}
								// 						</Menu>
								// 		</>,
								// 		endAdornment: <InputAdornment position="end" style={{marginRight: -8}}>
								// 			{
								// 				props.searchtext === '' || isUndefined(props.searchtext) ?
								// 				<IconButton size="small" onClick={_handleSearchBtn}><Search/></IconButton> :
								// 				<IconButton size="small" onClick={handleClear}><Clear/></IconButton>
								// 			}
								// 			</InputAdornment>,

								// 	}}
								// 	size="small"
								// 	variant="outlined"
								// 	onKeyDown={_handleSearch}
								// 	// onChange={(e) => isUndefined(props.handleSearchChange) ? () => {} : props.handleSearchChange(e)}
								// 	onChange={(e) => {setsearchtext(e.target.value)}}
								// />
							}
            </div>
        </div>
    )
}
export default injectIntl(TableHeader);
